import { render, staticRenderFns } from "./TravelOne.vue?vue&type=template&id=1b0b7bd6"
import script from "./TravelOne.vue?vue&type=script&lang=js"
export * from "./TravelOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports